import React , {useState, useEffect}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Procesando from '../Generales/Procesando'
//import {sucursal} from '../Generales/Storage';

function ConfiguracionSII(props) {

const [cargando, setCargando] = useState(false);
const [rut, setRut] = useState('');
const [razonSocial, setRazonSocial] = useState('');
const [giro, setGiro] = useState('');
const [direccion, setDireccion] = useState('');
const [comuna, setComuna] = useState('');
const [codigoActividades, setCodigoActiviades] = useState('');
const [fechaResolucion, setFechaResolucion] = useState('');
const [numeroResolucion, setNumeroResolucion] = useState('');
const [certificadoRUt, setCertificadoRut] = useState('');
const [certificadoNombre, setCertificadoNombre] = useState('');
const [certificadoPassword, setCertificadoPassword] = useState('');
const [certificadoPfxB64, setCertificadoPfxB64] = useState(null);
const [cafBoletaXml, setCafBoletaXml] = useState(null);
const [tieneCertificado, setTieneCertificado] = useState(false);
const [tieneCafBoleta, setTieneCafBoleta] = useState(false);
const [pedidoPrueba, setPedidoPrueba] = useState('');
const [resultadoEmision, setResultadoEmision] = useState(null);
const [enviaBoletasSii, setEnviaBoletasSii] = useState(false);
const [modoSii, setModoSii] = useState('CERTIFICACION');
const [cambiandoEstado, setCambiandoEstado] = useState(false);

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    getDatos()
    getEstadoBoletasSii()
},[]);

async function getEstadoBoletasSii(){
    await axios.get(config.api_url+'/configuracion/sii/estado/').then(resp=>{
        if (resp.data.completado){
            setEnviaBoletasSii(!!resp.data.envia_boletas_sii);
            setModoSii(resp.data.modo_sii);
        }
     }).catch(error=>{
        // silencioso -- no bloquea el resto del formulario
    })
}

async function onCambiarEnviaBoletasSii(activar){
    setCambiandoEstado(true);
    await axios.post(config.api_url+'/configuracion/sii/activar/', {activar}).then(resp=>{
        setCambiandoEstado(false);
        if (resp.data.completado){
            setEnviaBoletasSii(resp.data.envia_boletas_sii);
            toast.success(resp.data.mensaje);
        }else{
            toast.error(resp.data.mensaje);
        }
     }).catch(error=>{
        setCambiandoEstado(false);
        toast.error("Se ha generado un error al cambiar el estado!");
    })
}

async function getDatos(){
    setCargando(true);
    await axios.get(config.api_url+'/configuracion/sii/').then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            let datos = resp.data.datos;
            setRut(datos.rut_empresa)
            setRazonSocial(datos.razon_social);
            setGiro(datos.giro);
            setDireccion(datos.direccion);
            setComuna(datos.comuna);
            setCodigoActiviades(datos.codigos_actividades);
            setFechaResolucion(datos.fecha_resolucion);
            setNumeroResolucion(datos.nro_resolucion);
            setCertificadoNombre(datos.certificado_nombre);
            setCertificadoRut(datos.certificado_rut);
            setCertificadoPassword(datos.certificado_password);
            setTieneCertificado(!!datos.tiene_certificado);
            setTieneCafBoleta(!!datos.tiene_caf_boleta);
            setCargando(false);
        }else{
            setCargando(false);
            toast.error(resp.data.mensaje);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al traer los datos!");
    })  
}



function leerArchivoComoBase64(file){
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=> resolve(reader.result.split(',').pop());
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

async function onSeleccionarCertificado(ev){
    const file = ev.target.files[0];
    if (!file) return;
    const b64 = await leerArchivoComoBase64(file);
    setCertificadoPfxB64(b64);
}

async function onSeleccionarCaf(ev){
    const file = ev.target.files[0];
    if (!file) return;
    const texto = await file.text();
    setCafBoletaXml(texto);
}

async function Guardar(){
    setCargando(true);
    let parametros ={rutEmpresa:rut, razonSocial:razonSocial, giro:giro, direccion:direccion, comuna:comuna, codigoActividades:codigoActividades, fechaResolucion:fechaResolucion,numeroResolucion:numeroResolucion,
         certificadoRut:certificadoRUt,certificadoNombre:certificadoNombre, certificadoPassword:certificadoPassword}
    // Solo se envían si el usuario seleccionó un archivo nuevo -- si no, el
    // backend conserva lo que ya estaba guardado.
    if (certificadoPfxB64) parametros.certificadoPfxB64 = certificadoPfxB64;
    if (cafBoletaXml) parametros.cafBoletaXml = cafBoletaXml;
    await axios.post(config.api_url+'/configuracion/sii/', parametros).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){
            toast.success(resp.data.mensaje);
            if (certificadoPfxB64) setTieneCertificado(true);
            if (cafBoletaXml) setTieneCafBoleta(true);
            setCargando(false);
        }else{
            toast.success(resp.data.mensaje);
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al guardar los datos!");
    })
}

async function EmitirBoletaPrueba(){
    if (!pedidoPrueba){
        toast.error("Ingrese el ID del pedido a emitir.");
        return;
    }
    setCargando(true);
    setResultadoEmision(null);
    await axios.post(config.api_url+'/api/sii/boleta/emitir', {pedido_id: pedidoPrueba}).then(resp=>{
        setCargando(false);
        setResultadoEmision(resp.data);
        if (resp.data.completado){
            toast.success(resp.data.mensaje);
        }else{
            toast.error(resp.data.mensaje);
        }
    }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al emitir la boleta!");
    })
}


return  (       
        <div className='card' style={{height:"100vh"}}>
            <ToastContainer />
            <Modal
                open={cargando}
                showCloseIcon={false}
                center
                >
                <Procesando/>
            </Modal>
            <div className='card-header'>
                <div className='row'>
                    <div className='col-md-4'>
                            <a href='/configuracion/home/'><i class="bi bi-arrow-left-short"></i>Regresar</a>   
                        </div>
                    <div className='col-md-4 titulo-formulario'>
                        <label>Configuración SII</label>
                    </div>
                </div>
            </div>
            <br/>
            <div className='card-body'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='container'>
                            <div className='row p-2 rounded' style={{background: enviaBoletasSii ? '#e6f9ed' : '#f8f9fa', border: '1px solid ' + (enviaBoletasSii ? '#28a745' : '#dee2e6')}}>
                                <div className='col-8'>
                                    <label className='mb-0'><b>Boletas Electrónicas SII</b></label>
                                    <div className='small text-muted'>
                                        {enviaBoletasSii
                                            ? `Activo — modo ${modoSii === 'PRODUCCION' ? 'Producción 🚀' : 'Certificación 🔬 (pruebas)'}`
                                            : 'Desactivado — se emiten comprobantes normales al cobrar.'}
                                    </div>
                                    {enviaBoletasSii && modoSii !== 'PRODUCCION' &&
                                        <div className='small text-muted'>El paso a Producción lo habilita el equipo de Komity una vez validado tu certificado y CAF.</div>
                                    }
                                </div>
                                <div className='col-4 d-flex align-items-center justify-content-end'>
                                    <div className='custom-control custom-switch'>
                                        <input
                                            type='checkbox'
                                            className='custom-control-input'
                                            id='enviaBoletasSiiSwitch'
                                            checked={enviaBoletasSii}
                                            disabled={cambiandoEstado}
                                            onChange={(ev)=>onCambiarEnviaBoletasSii(ev.target.checked)}
                                        />
                                        <label className='custom-control-label' htmlFor='enviaBoletasSiiSwitch'></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {enviaBoletasSii &&
                <>
                <div className='row'>
                <div className='col-md-12'>
                    <div className='container'>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Rut:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={rut} onChange={(ev)=>setRut(ev.target.value)}/>
                            </div>
                       </div>
                       <br></br>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Razón Social:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={razonSocial} onChange={(ev)=>setRazonSocial(ev.target.value)}/>
                            </div>
                       </div>
                       <br></br>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Giro:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={giro} onChange={(ev)=>setGiro(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Dirección:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={direccion} onChange={(ev)=>setDireccion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/> 
                       <div className='row'>
                            <div className='col-2'>
                                <label>Comuna:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={comuna} onChange={(ev)=>setComuna(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Código actividades:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={codigoActividades} onChange={(ev)=>setCodigoActiviades(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Fecha Resolución:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={fechaResolucion} onChange={(ev)=>setFechaResolucion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Numero Resolución:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={numeroResolucion} onChange={(ev)=>setNumeroResolucion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Certificado Rut:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={certificadoRUt} onChange={(ev)=>setCertificadoRut(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Certificado Nombre:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={certificadoNombre} onChange={(ev)=>setCertificadoNombre(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Password certificado:</label>
                            </div>
                            <div className='col-4'>
                                <input type='password' className='form-control' value={certificadoPassword} onChange={(ev)=>setCertificadoPassword(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Certificado digital (.pfx):</label>
                            </div>
                            <div className='col-8'>
                                <input type='file' accept='.pfx,.p12' className='form-control' onChange={onSeleccionarCertificado}/>
                                <small>{tieneCertificado ? '✅ Ya hay un certificado cargado. Seleccione un archivo solo si desea reemplazarlo.' : 'Sin certificado cargado.'}</small>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>CAF Boleta Electrónica (.xml):</label>
                            </div>
                            <div className='col-8'>
                                <input type='file' accept='.xml' className='form-control' onChange={onSeleccionarCaf}/>
                                <small>{tieneCafBoleta ? '✅ Ya hay un CAF cargado. Seleccione un archivo solo si desea reemplazarlo.' : 'Sin CAF cargado.'}</small>
                            </div>
                       </div>
                    </div>
                </div>
                </div>
                <br/>
                <div className='row'>
                    <div className='col-md-12'>
                        <button className='btn btn-primary' onClick={Guardar}> Guardar </button>
                    </div>
                </div>
                <br/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='container'>
                            <h6>Emitir boleta de prueba</h6>
                            <div className='row'>
                                <div className='col-2'>
                                    <label>ID Pedido:</label>
                                </div>
                                <div className='col-4'>
                                    <input type='text' className='form-control' value={pedidoPrueba} onChange={(ev)=>setPedidoPrueba(ev.target.value)}/>
                                </div>
                                <div className='col-4'>
                                    <button className='btn btn-secondary' onClick={EmitirBoletaPrueba}>Emitir al SII</button>
                                </div>
                            </div>
                            {resultadoEmision &&
                                <div className='row' style={{marginTop:'10px'}}>
                                    <div className='col-12'>
                                        <pre>{JSON.stringify(resultadoEmision, null, 2)}</pre>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                </>
                }
            </div>


        </div>

    );
}

export default ConfiguracionSII;